import React, {useRef, useState, useEffect} from 'react';

import * as S from './TransactionVerify.styles';

import OTPBlock from '../../../../../../../onboarding/src/stories/components/UI/OTP/otp';

const TransactionVerify = ({data, otpError, callback, resendOTP, userVerified, otpVerificationDone, closeModal}) => {
  const [msg, setMsg] = useState('');

  useEffect(() => {
    if (data && data.text_message) {
      setMsg(data.text_message);
    }
  }, data)

  const otpRef = useRef(null);

  const verifyOTP = () => {
    const otpStr = otpRef.current.value;
    callback(otpStr);
  }

  return(
    <S.TransactionVerifyMainWrap>
      <S.VerifyHeadWrap>
        <S.VerifyTextWrap>
          <S.VerifyPopHeadText>Verify Transaction</S.VerifyPopHeadText>
          <S.VerifyPopHeadSubText>Please enter OTP sent to your registered mobile number.</S.VerifyPopHeadSubText>
        </S.VerifyTextWrap>
        <S.CloseIconWrap onClick={closeModal}></S.CloseIconWrap>
      </S.VerifyHeadWrap>
      <S.VerifyOtpInfoWrap>
        <OTPBlock
          ref={otpRef}
          label=""
          subLabel=""
          otpLength={4}
          type="motp"
          resendOTP={() => resendOTP(true)}
          autoFocus={true}
          resendVisible={data && data.sms_count && data.sms_count < 3}
        />
      </S.VerifyOtpInfoWrap>
      {/* <S.VerifyHeadWrap>
        <S.VerifyPopMsg>{msg}</S.VerifyPopMsg>
      </S.VerifyHeadWrap> */}
      {(otpError && <S.ErrorText>{otpError}</S.ErrorText>) || null}
      <S.VerifyOtpBtnWrap onClick={verifyOTP}>
        <S.VerifyBtn>Verify</S.VerifyBtn>
      </S.VerifyOtpBtnWrap>
    </S.TransactionVerifyMainWrap>
  );
}

export default TransactionVerify;